import React, { useState, useEffect } from "react";
import { Container, SubmitButton, Title } from "./styles";
import Uploader from "../../components/Uploader/Uploader";
import api from "../../services/api";
import * as XLSX from "xlsx";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { MDBRow, MDBProgress, MDBProgressBar } from "mdb-react-ui-kit";

const InsertESL = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [progress, setProgress] = useState(0);
  const leroyCode = localStorage.getItem("code");
  const [successCount, setSuccessCount] = useState(0);
  const [errors, setErrors] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  useEffect(() => {
    if (progress === 100) {
      setProgress(100);
    }

    if (isProcessing && progress === 100) {
      setIsProcessing(false);

      toast.success(`MACs inseridos com sucesso!`);
      if (errors.length > 0) {
        errors.forEach((error) => {
          toast.error(`MACs ${error.mac} duplicado!`);
        });
      }
    }
  }, [isProcessing, progress, successCount, errors]);

  const handleFileSelect = (file) => {
    setSelectedFile(file);
  };

  const handleFileLoad = (event) => {
    const fileData = event.target.result;
    const workbook = XLSX.read(fileData, { type: "array" });
    const sheetName = workbook.SheetNames[0];
    const worksheet = workbook.Sheets[sheetName];
    const jsonData = XLSX.utils.sheet_to_json(worksheet);
    const promises = [];
    const newErrors = [];

    setProgress(0);
    setSuccessCount(0);
    setErrors([]);
    setIsProcessing(true);

    jsonData.forEach((row, index) => {
      const values = Object.values(row);

      const data = {
        mac: values[0],
        size: values[1],
        isMinew: values[2],
      };

      if (data.isMinew === "1" || data.isMinew === 1) {
        data.isMinew = true;
      } else {
        data.isMinew = false;
      }

      const promise = new Promise((resolve) => {
        api
          .post(`/insert/esl?leroyCode=${leroyCode}`, data)
          .then(() => {
            resolve({ success: true, mac: data.mac });
          })
          .catch((error) => {
            let errorMessage = "Erro ao inserir ESL";
            if (
              error.response &&
              error.response.data &&
              error.response.headers["content-type"].includes(
                "application/json"
              )
            ) {
              try {
                errorMessage = JSON.parse(error.response.data).message;
              } catch (parseError) {
                console.error(
                  "Erro ao fazer o parse da resposta JSON",
                  parseError
                );
              }
            }
            newErrors.push({ mac: data.mac, error: errorMessage });
            resolve({ success: false, mc: data.mac, error: errorMessage });
          })
          .finally(() => {
            const newProgress = Math.floor(
              ((index + 1) / jsonData.length) * 100
            );
            setProgress(newProgress);
          });
      });

      promises.push(promise);
    });

    Promise.all(promises)
      .then((results) => {
        const count = results.filter((result) => result.success).length;
        setSuccessCount(count);
        setErrors(newErrors);
        setProgress(100);
      })
      .catch((error) => {
        toast.error("Erro ao inserir ESLs.");
      });
  };

  const handleSendButtonClick = () => {
    if (selectedFile) {
      const reader = new FileReader();
      reader.onload = handleFileLoad;
      reader.readAsArrayBuffer(selectedFile);
    }
  };

  return (
    <>
      <ToastContainer />
      <Title className="text-start">
        <h3>Inserir novas ESLs</h3>
        <MDBRow>
          <MDBProgress height="20">
            <MDBProgressBar width={progress} striped animated>
              {parseInt(progress)}%
            </MDBProgressBar>
          </MDBProgress>
        </MDBRow>
      </Title>
      <Container>
        <MDBRow>
          <Uploader onFileSelect={handleFileSelect} />
        </MDBRow>
        <MDBRow>
          <SubmitButton
            onClick={handleSendButtonClick}
            disabled={!selectedFile}
          >
            Enviar
          </SubmitButton>
        </MDBRow>
      </Container>
    </>
  );
};

export default InsertESL;
